import { formatISO } from "date-fns";

export const formatDateToISOString = (date: Date) => {
  return formatISO(date, { representation: "complete" });
};

export const getCurrentISODate = () => {
  return formatDateToISOString(new Date());
};
